import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../../theme/palette';

const style = () =>
  createStyles({
    container: {
      cursor: 'pointer',
      fontWeight: 500,
      backgroundColor: palette.background.box,
      display: 'flex',
      gap: '10px',
      color: 'white',
      borderRadius: palette.borderRadius.default,
      padding: '7.5px 10px 7.5px 10px',
      '&:focus': {
        outline: 'none'
      },
      boxShadow: palette.shadows.boxShadow
    },
    children: {
      color: palette.title.primary,
      padding: '2.5px 5px 2.5px 5px',
      borderRadius: palette.borderRadius.large
    },
    selected: {
      color: palette.common.white,
      backgroundColor: palette.common.primaryBlue,
      transition: 'all 0.5s'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
